export default __webpack_public_path__ + "static/media/paypal.8f8756dd.svg";